export default "<p>\r\n  About works!\r\n</p>\r\n"